function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { colors as defaultColors } from '@airwallex/global';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import merge from 'lodash/merge';
import { buttonColorThemeSchema } from './button';
import { textInputColorThemeSchema } from './textInput';
export var COMPONENT_TYPE_SCHEMA = {
  button: buttonColorThemeSchema,
  textInput: textInputColorThemeSchema
};

/**
 * Build color schema object for FEC component, using the schema mapping provided.
 * It uses global colors by default, if no themed color object is passed as param.
 */
export var getComponentTheme = function getComponentTheme(_ref) {
  var componentType = _ref.componentType,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? defaultColors : _ref$colors,
      colorsOverride = _ref.colorsOverride;
  // pick the corresponding schema
  var themeSchema = COMPONENT_TYPE_SCHEMA[componentType]; // if component level customization provided, should override again

  var preparedColors = merge({}, colors, colorsOverride);

  var buildColorTheme = function buildColorTheme(colorTheme) {
    Object.entries(colorTheme).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];

      if (typeof value === 'string') {
        var color = get(preparedColors, value);
        colorTheme[key] = color;
      } else {
        colorTheme[key] = buildColorTheme(colorTheme[key]);
      }
    });
    return colorTheme;
  };

  return buildColorTheme(cloneDeep(themeSchema));
};